module.exports = __webpack_public_path__ + "img/mingyong62.556e629b.png";